<div class="collector-detail">
  <div class="detail-grid">
    <app-collector-identity-card
      [collector]="collector"
    ></app-collector-identity-card>
    <app-collector-editable-profile-card
      [collector]="collector"
      [config]="config"
      (change)="onCollectorChanged()"
    ></app-collector-editable-profile-card>
    <app-collector-metrics-card
      [collector]="collector"
    ></app-collector-metrics-card>
    <app-collector-assessment-card
      [collector]="collector"
      [config]="config"
      (change)="onCollectorChanged()"
    ></app-collector-assessment-card>
    <app-collector-event-skills-card
      [collector]="collector"
      [config]="config"
      (change)="onCollectorChanged()"
    ></app-collector-event-skills-card>
    <app-collector-event-combinations-card
      [collector]="collector"
      [config]="config"
      (change)="onCollectorChanged()"
    ></app-collector-event-combinations-card>
  </div>
</div>
